import { MultiLabelFormattingProps } from '../types';
import { TabLayout } from '../TabLayout';
import { PerspectivesLabelFormattingWithMultiselect } from './multiselect/PerspectivesLabelFormattingWithMultiselect';

export const LabelsTab = (props: MultiLabelFormattingProps) => (
  <TabLayout
    sections={[
      {
        key: 'labels',
        content: <PerspectivesLabelFormattingWithMultiselect {...props} />,
      },
    ]}
  />
);
